import  { Suspense, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CircularProgress, Grid } from '@mui/material';
import { ENV_CONFIG } from './constant';
import { loginWithOuth } from './sevices/account';
import { getCurrentUserData, isEmptyObj, isExpiredRefreshToken, setCurrentUser } from './utils/genericUtilities';
import RouteComponent from './routes';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import './App.scss';
import ScrollToTop from './routes/scrollToTop';
import { HelmetProvider } from 'react-helmet-async';

// APP FUNCTION 
function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false); 

// // REFRESH ACCESS TOKEN FUNCTION 
//   const refreshAccessToken = async () => {
//     const userData = getCurrentUserData();
//     setIsRefreshing(true);
//     if (!userData || !userData.refresh_token) {
//       return;
//     }

//     const requestParams = {
//       refresh_token: userData.refresh_token,
//       client_id: ENV_CONFIG.CLIENT_ID,
//       client_secret: ENV_CONFIG.CLIENT_SECRET,
//       grant_type: "refresh_token"
//     };

//     try {
//       const response = await loginWithOuth(requestParams);
//       if (response?.status === 200) {
//         const expires_in = Date.now() + (response?.data?.expires_in * 1000);
//         setCurrentUser({ ...response?.data, expires_in });
//         setAuthenticated(true);
//       }else{
//         console.error('Refresh token validation failed:', response.data);
//       }
//     } catch (err) {
//       console.log("ererroewiroiewru",err)
//     }
//     finally{
//       setIsRefreshing(false);
//     }
//   };


  // useEffect(() => {
  //   // GET CURRENT USER DATA FUNCTION
  //   const findUser = getCurrentUserData();
  //   if (!isEmptyObj(findUser) && findUser?.access_token) {
  //     // Check for token expiration before setting authenticated state
  //     if (!isExpiredRefreshToken(findUser)) {
  //       setAuthenticated(true);
  //       setCurrentUser(findUser); // Set user data for convenience
  //     } else {
  //       // Refresh token if necessary
  //       refreshAccessToken();
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   // Check token expiration periodically (adjust interval as needed)
  //   const tokenExpirationInterval = setInterval(() => {
  //     if (isExpiredRefreshToken(getCurrentUserData())) {
  //       refreshAccessToken();
  //     }
  //   }, 10 * 60 * 1000); // Check every 10 minutes

  //   return () => clearInterval(tokenExpirationInterval);
  // }, []);

  const helmetContext = {};
  return (
    <BrowserRouter>
      <HelmetProvider context={helmetContext}>
        <ScrollToTop>
          <Suspense
            fallback={
              <Grid item md={12} height={"90vh"} display={'flex'} justifyContent="center" alignItems={"center"}>
                <CircularProgress />
              </Grid>
            }
          >
       <RouteComponent authenticated={authenticated} isRefreshing={isRefreshing} />
            {/* <RouteComponent /> */}
          </Suspense>
        </ScrollToTop>
      </HelmetProvider> 
    </BrowserRouter>
  );
}

export default App;
